import SentimentModal from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/SentimentModal/SentimentModal';

export default SentimentModal;
